import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import {
  Div, InputWithLabel, Icon, Button, H4, SmallText, Checkbox, RadioGroup, CheckboxGroup, Input, P, Radio,
} from 'konsys-ui'
import {
  message, Row, Col, AutoComplete, Popover, notification, Select as Tag,
} from 'antd'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { Trash2 } from 'lucide-react'
import { CREATE_INVENTORY, UPDATE_INVENTORY } from '../../../constants/graph/mutation'
import {
  WAREHOUSE, SUPPLIERS, BRANDS, CATEGORIES, WAREHOUSES, VARIANTOPTIONSKEY, GET_OPTIONS, GET_TAGS, INVENTORY, INVENTORIES,
} from '../../../constants/graph/query'
import {
  FullPageContainer, Divider, SelectWithLabel, Select as KonsysSelect, DashedButton, Uploader, Log, Select,
} from '../../../components/common'
import { RadioWrapper } from '../styled'
import { theme } from '../../../styles/_variables'
import {
  SALE_TYPE, PRODUCT_GROUP, STOCK_TYPE, VAT_TYPE, detailMode,
} from '../constants'
import { verifyFields, checkFloat, checkInt } from '../../../utils/util-services'
import history from '../../../history'


const initialNewVariantData = {
  initialCost: undefined,
  initialStock: undefined,
  isVat: false,
}

const initialNewLocationData = {
  quantity: undefined,
  warehouseId: undefined,
  isNew: true,
}

const VariantOptionForm = ({
  inventoryOption, setInventoryOption, isCreateMode, data, warehousesData,
}) => (
  <Div>
  {
    inventoryOption.map((sku, index) => (
      <Div key={index} margin='40px 0 0 0'>
        <Div display='flex' width='100%' justifyContent='space-between' alignItems='center'>
        {
            isCreateMode
              ? <P bold color={theme.color.primaryColor}>{sku.variantName}</P>
              : <Input defaultValue={sku.variantName} onChange={(e) => {
                setInventoryOption(inventoryOption.map((variant) => {
                  if (variant.id === sku.id) {
                    return ({
                      ...variant,
                      variantName: e.target.value,
                    })
                  } return variant
                }))
              }} />
          }
          {
            _.size(inventoryOption) > 1 && !_.includes(_.keys(sku), '__typename')
              && <Trash2 className='cursor-pointer text-blue-500' onClick={() => setInventoryOption(_.remove(_.cloneDeep(inventoryOption), o => o.id !== sku.id))}/>
          }
        </Div>
        <Divider
          color={theme.color.veryLightBlue}
          margin='16px 0'
        />
        <Row style={{ margin: '8px 0' }}>
          <Col span={24}>
            <Uploader
              // buttonText='อัพโหลดรูปประจำรุ่นสินค้า'
              buttonText='อัพโหลดรูปสินค้า'
              onChange={e => setInventoryOption(inventoryOption.map((val) => {
                if (val.id === sku.id) {
                  return ({
                    ...val,
                    file: e,
                  })
                }
                return val
              }))}
            //  data={isCreateMode ? [] : sku.url }
             data={isCreateMode || sku.file ? sku.file : sku.url ? [{ name: _.flatten(_.takeRight(_.split(sku.url, '/'))), uid: sku.url, url: sku.url }] : []}
             isMultiple={false}
             accept='image/*'
            />
          </Col>
        </Row>
        <Row type='flex' gutter={16} align='middle'>
          <Col
            xs={24}
            lg={6}
          >
            <SmallText bold>รหัสสินค้า *</SmallText>
            <Div display='flex' alignItems='center'>
              <Input
                width='100%'
                defaultValue={isCreateMode ? undefined : sku.sku}
                onChange={e => setInventoryOption(inventoryOption.map((val) => {
                  if (val.id === sku.id) {
                    return ({
                      ...val,
                      sku: e.target.value,
                    })
                  }
                  return val
                }))}
              />
            </Div>
          </Col>
          <Col
            xs={24}
            md={12}
            lg={6}
          >
            <SmallText bold>ต้นทุน *</SmallText>
            <Div display='flex' alignItems='center'>
              <Input
                width='100%'
                type='number'
                min='0'
                step={0.01}
                onKeyDown={e => !checkFloat(e) && e.preventDefault()}
                disabled= { !isCreateMode && !sku.isNew }
                defaultValue= {isCreateMode ? undefined : sku.initialCost}
                onChange={e => setInventoryOption(inventoryOption.map((val) => {
                  if (val.id === sku.id) {
                    return ({
                      ...val,
                      initialCost: parseFloat(e.target.value),
                    })
                  }
                  return val
                }))}
              />
            </Div>
          </Col>
          <Col
            xs={24}
            md={12}
            lg={6}
          >
            {/* <Popover
              content={<P color={theme.color.error}>สต๊อกเริ่มต้นไม่เท่าสต๊อกในคลัง</P>}
              visible={sku.initialStock !== _.sum(sku.location.map(v => v.quantity))}
            > */}
            <SmallText bold>จำนวนสต๊อกเริ่มต้น *</SmallText>
            <Div display='flex' alignItems='center'>
              <Input
                width='100%'
                type='number'
                min='0'
                step={1}
                onKeyDown={e => !checkInt(e) && e.preventDefault()}
                disabled= { !isCreateMode && !sku.isNew }
                defaultValue= {isCreateMode ? undefined : sku.initialStock}
                onChange={e => setInventoryOption(inventoryOption.map((val) => {
                  if (val.id === sku.id) {
                    return ({
                      ...val,
                      initialStock: parseInt(e.target.value, 10),
                    })
                  }
                  return val
                }))}
              />
            </Div>
            {/* </Popover> */}
          </Col>
          <Col
            xs={24}
            md={12}
            lg={6}
          >
            <SmallText bold>จำนวนสต๊อกขั้นต่ำ</SmallText>
            <Div display='flex' alignItems='center'>
              <Input
                width='100%'
                type='number'
                min='0'
                step={1}
                onKeyDown={e => !checkInt(e) && e.preventDefault()}
                defaultValue= {isCreateMode ? undefined : sku.minimumStock}
                onChange={e => setInventoryOption(inventoryOption.map((val) => {
                  if (val.id === sku.id) {
                    return ({
                      ...val,
                      minimumStock: parseInt(e.target.value, 10),
                    })
                  }
                  return val
                }))}
              />
            </Div>
          </Col>
        </Row>
        <Row type='flex' gutter={16} align='middle'>
          <Col
            xs={24}
            md={12}
            lg={12}
          >
            <SmallText bold>ราคาซื้อสุทธิ</SmallText>
            <Div display='flex' alignItems='center'>
              <Input
                width='100%'
                type='number'
                min='0'
                step={0.01}
                onKeyDown={e => !checkFloat(e) && e.preventDefault()}
                defaultValue= {isCreateMode ? undefined : sku.buyPrice}
                onChange={e => setInventoryOption(inventoryOption.map((val) => {
                  if (val.id === sku.id) {
                    return ({
                      ...val,
                      buyPrice: parseFloat(e.target.value),
                    })
                  }
                  return val
                }))}
              />
            </Div>
          </Col>
          <Col
            xs={24}
            md={12}
            lg={12}
          >
            <SmallText bold>ราคาขาย</SmallText>
            <Div display='flex' alignItems='center'>
              <Input
                width='100%'
                type='number'
                min='0'
                step={0.01}
                onKeyDown={e => !checkFloat(e) && e.preventDefault()}
                defaultValue= {isCreateMode ? undefined : sku.salesPrice}
                onChange={e => setInventoryOption(inventoryOption.map((val) => {
                  if (val.id === sku.id) {
                    return ({
                      ...val,
                      salesPrice: parseFloat(e.target.value),
                    })
                  }
                  return val
                }))}
              />
            </Div>
          </Col>
        </Row>
        <Row type='flex' gutter={8} align='middle'>
          <Col
            span={12}
          >
            <SmallText bold>สถานที่จัดเก็บ *</SmallText>
          </Col>
          <Col
            span={6}
          >
            <SmallText bold>ชั้นวาง</SmallText>
          </Col>
          <Col
            span={5}
          >
            <SmallText bold>จำนวน *</SmallText>
          </Col>
          <Col span={1}/>
        </Row>
        {
          sku.location.map(v => (
            <Row key={v.id} type='flex' gutter={8} align='middle' style={{ margin: '8px -8px' }}>
              <Col
                span={12}
              >
                <KonsysSelect
                  style={{ width: '100%' }}
                  onChange={(e) => {
                    const newLocations = sku.location.map((val) => {
                      if (val.id === v.id) return ({ ...v, warehouseId: e })
                      return val
                    })
                    setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return { ...val, location: newLocations }
                      } return val
                    }))
                  }}
                  disabled={_.includes(_.keys(v), '__typename')}
                  placeholder='เลือกสถานที่จัดเก็บ'
                  defaultValue={isCreateMode || !v.warehouse ? undefined : v.warehouse.warehouseName}
                  options={
                    _.remove(_.cloneDeep(warehousesData.warehouseList.data.list), o => !_.includes(sku.location.map(location => location.warehouseId), o.id)).map(value => ({
                      value: value.id,
                      text: value.warehouseName,
                    }))
                  }
                />
              </Col>
              <Col
                span={6}
              >
                <Input
                  width='100%'
                  defaultValue={isCreateMode ? undefined : v.shelf}
                  placeholder='กรอกชั้นวาง'
                  onChange={(e) => {
                    const newLocations = sku.location.map((val) => {
                      if (val.id === v.id) return ({ ...v, shelf: e.target.value })
                      return val
                    })
                    setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return { ...val, location: newLocations }
                      } return val
                    }))
                  }}
                />
              </Col>
              <Col
                span={5}
              >
                <Input
                  width='100%'
                  defaultValue={isCreateMode ? undefined : v.quantity}
                  disabled={!isCreateMode}
                  placeholder='กรอกจำนวน'
                  state='default'
                  rule={{ type: 'int' }}
                  onChange={(e) => {
                    const newLocations = sku.location.map((val) => {
                      if (val.id === v.id) return ({ ...v, quantity: parseInt(e.target.value, 10) })
                      return val
                    })
                    setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return { ...val, location: newLocations }
                      } return val
                    }))
                  }}
                />
              </Col>
              <Col span={1}>
              {
                (_.size(sku.location) > 1 && !_.includes(_.keys(v), '__typename'))
                  && <Trash2 className='cursor-pointer text-blue-500' onClick={() => {
                    const newLocations = _.remove(_.cloneDeep(sku.location), o => o.id !== v.id)
                    setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return { ...val, location: newLocations }
                      } return val
                    }))
                  }}/>
              }
              </Col>
            </Row>
          ))
        }
        <DashedButton width='100%' margin='16px 0 0 0' text='เพิ่มสถานที่จัดเก็บ' icon='fal fa-plus' onClick={() => setInventoryOption(inventoryOption.map((v) => {
          if (v.id === sku.id) {
            return ({
              ...sku,
              location: [...sku.location, { id: sku.location.length + 1, ...initialNewLocationData }],
            })
          } return v
        }))} />
      </Div>
    ))
  }
  </Div>
)

const PackOptionForm = ({
  inventoryOption, setInventoryOption, isCreateMode, data, warehousesData,
}) => (
  <Div>
    <Row style={{ margin: '8px 0' }}>
      <Col span={24}>
        <Uploader
          // buttonText='อัพโหลดรูปประจำรุ่นสินค้า'
          buttonText='อัพโหลดรูปสินค้า'
          onChange={e => setInventoryOption(inventoryOption.map(v => ({ ...v, file: e })))}
        data={inventoryOption[0].file}
        isMultiple={false}
        accept='image/*'
        />
      </Col>
    </Row>
    <Row type='flex' gutter={16} align='middle'>
      <Col
        xs={24}
        lg={4}
      >
        <InputWithLabel
          width='100%'
          input={{
            width: '100%',
            defaultValue: isCreateMode ? undefined : inventoryOption[0].sku,
            placeholder: 'กรอกรหัสสินค้า',
          }}
          onChange={e => setInventoryOption(inventoryOption.map(v => ({ ...v, sku: e.target.value })))}
          title={{ text: 'รหัสสินค้า' }}
        />
      </Col>
      <Col
        xs={24}
        md={12}
        lg={4}
      >
        <InputWithLabel
          width='100%'
          input={{
            width: '100%',
            defaultValue: isCreateMode ? undefined : inventoryOption[0].initialCost,
            placeholder: 'กรอกต้นทุน',
            state: 'default',
            rule: { type: 'int' },
            disabled: !isCreateMode,
          }}
          onChange={e => setInventoryOption(inventoryOption.map(v => ({ ...v, initialCost: parseFloat(e.target.value) })))}
          title={{ text: 'ต้นทุน' }}
        />
      </Col>
      <Col
        xs={24}
        md={12}
        lg={4}
      >
        <InputWithLabel
          width='100%'
          input={{
            width: '100%',
            defaultValue: isCreateMode ? undefined : inventoryOption[0].initialStock,
            placeholder: 'กรอกจำนวนสต๊อกเริ่มต้น',
            state: 'default',
            rule: { type: 'int' },
            disabled: !isCreateMode,
          }}
          onChange={e => setInventoryOption(inventoryOption.map(v => ({ ...v, initialStock: parseInt(e.target.value, 10) })))}
          title={{ text: 'จำนวนสต๊อกเริ่มต้น' }}
        />
      </Col>
      <Col
        xs={24}
        md={12}
        lg={4}
      >
        <InputWithLabel
          width='100%'
          input={{
            width: '100%',
            defaultValue: isCreateMode ? undefined : inventoryOption[0].minimumStock,
            placeholder: 'กรอกจำนวนสต๊อกขั้นต่ำ',
            state: 'default',
            rule: { type: 'int' },
          }}
          onChange={e => setInventoryOption(inventoryOption.map(v => ({ ...v, minimumStock: parseInt(e.target.value, 10) })))}
          title={{ text: 'จำนวนสต๊อกขั้นต่ำ' }}
        />
      </Col>
      <Col
        xs={24}
        md={12}
        lg={4}
      >
        <InputWithLabel
          width='100%'
          input={{
            width: '100%',
            defaultValue: isCreateMode ? undefined : inventoryOption[0].buyPrice,
            placeholder: 'กรอกราคาซื้อ (ต่อหน่วย)',
            state: 'default',
            rule: { type: 'float' },
          }}
          onChange={e => setInventoryOption(inventoryOption.map(v => ({ ...v, buyPrice: parseFloat(e.target.value) })))}
          title={{ text: 'ราคาซื้อ (ต่อหน่วย)' }}
        />
      </Col>
      <Col
        xs={24}
        md={12}
        lg={4}
      >
        <SelectWithLabel
          width='100%'
          title={{
            text: 'VAT',
          }}
          select={{
            style: { width: '100%' },
            placeholder: 'เลือกการเก็บ VAT',
            // value: VAT_TYPE.VAT7,
            // disabled: true,
            defaultValue: _.isNil(inventoryOption[0].isVat) ? undefined : inventoryOption[0].isVat ? inventoryOption[0].vat === 0 ? VAT_TYPE.VAT0 : VAT_TYPE.VAT7 : VAT_TYPE.NO_VAT,
            onChange: e => setInventoryOption(inventoryOption.map((val) => {
              switch (e) {
                case VAT_TYPE.NO_VAT:
                  return ({
                    ...val,
                    isVat: false,
                  })
                case VAT_TYPE.VAT0:
                  return ({
                    ...val,
                    isVat: true,
                    vat: 0,
                  })
                case VAT_TYPE.VAT7:
                  return ({
                    ...val,
                    isVat: true,
                    vat: 7,
                  })
                default: return val
              }
            })),
            options: [
              { text: 'ไม่คิด VAT', value: VAT_TYPE.NO_VAT },
              { text: 'VAT 0%', value: VAT_TYPE.VAT0 },
              { text: 'VAT 7%', value: VAT_TYPE.VAT7 },
            ],
          }}
        />
      </Col>
    </Row>
    <Row type='flex' gutter={8} align='middle'>
      <Col
        span={12}
      >
        <SmallText bold>สถานที่จัดเก็บ</SmallText>
      </Col>
      <Col
        span={6}
      >
        <SmallText bold>ชั้นวาง</SmallText>
      </Col>
      <Col
        span={5}
      >
        <SmallText bold>จำนวน</SmallText>
      </Col>
      <Col span={1} />
    </Row>
    {
      inventoryOption[0].location.map(v => (
        <Row key={v.id} type='flex' gutter={8} align='middle' style={{ margin: '8px -8px' }}>
          <Col
            span={12}
          >
            <KonsysSelect
              style={{ width: '100%' }}
              onChange={(e) => {
                const newLocations = inventoryOption[0].location.map((val) => {
                  if (val.id === v.id) return ({ ...v, warehouseId: e })
                  return val
                })
                setInventoryOption(
                  [{
                    ...inventoryOption[0],
                    location: newLocations,
                  }],
                )
              }}
              placeholder='เลือกสถานที่จัดเก็บ'
              defaultValue={isCreateMode || !v.warehouse ? undefined : v.warehouse.warehouseName}
              options={
                _.remove(_.cloneDeep(warehousesData.warehouseList.data.list), o => !_.includes(inventoryOption[0].location.map(location => location.warehouseId), o.id)).map(value => ({
                  value: value.id,
                  text: value.warehouseName,
                }))
              }
            />
          </Col>
          <Col
            span={6}
          >
            <Input
              width='100%'
              // defaultValue={isCreateMode ? undefined : data.inventoryInfo.data.warehouseCode}
              placeholder='กรอกชั้นวาง'
              defaultValue={isCreateMode ? undefined : v.shelf}
              onChange={(e) => {
                const newLocations = inventoryOption[0].location.map((val) => {
                  if (val.id === v.id) return ({ ...v, shelf: e.target.value })
                  return val
                })
                setInventoryOption(
                  [{
                    ...inventoryOption[0],
                    location: newLocations,
                  }],
                )
              }}
            />
          </Col>
          <Col
            span={5}
          >
            <Input
              width='100%'
              // defaultValue={isCreateMode ? undefined : data.inventoryInfo.data.warehouseCode}
              placeholder='กรอกจำนวน'
              state='default'
              rule={{ type: 'int' }}
              disabled={!isCreateMode}
              defaultValue={isCreateMode ? undefined : v.quantity}
              onChange={(e) => {
                const newLocations = inventoryOption[0].location.map((val) => {
                  if (val.id === v.id) return ({ ...v, quantity: parseInt(e.target.value, 10) })
                  return val
                })
                setInventoryOption(
                  [{
                    ...inventoryOption[0],
                    location: newLocations,
                  }],
                )
              }}
            />
          </Col>
          <Col span={1}>
          {
            (_.size(inventoryOption[0].location) > 1 && !_.includes(_.keys(v), '__typename'))
              && <Trash2 className='cursor-pointer text-blue-500' onClick={() => {
                const newLocations = _.remove(_.cloneDeep(inventoryOption[0].location), o => o.id !== v.id)
                setInventoryOption(
                  [{
                    ...inventoryOption[0],
                    location: newLocations,
                  }],
                )
              }}/>
          }
          </Col>
        </Row>
      ))
    }
    <DashedButton width='100%' margin='16px 0 0 0' text='เพิ่มสถานที่จัดเก็บ' icon='fal fa-plus' onClick={() => setInventoryOption([
      {
        ...inventoryOption[0],
        location: [...inventoryOption[0].location, { id: `${_.maxBy(inventoryOption[0].location, 'id').id}_NEW`, ...initialNewLocationData }],
      },
    ])} />
    <Divider
      color={theme.color.veryLightBlue}
      margin='16px 0'
    />
  {
    inventoryOption[0].pack.map((pack, index) => (
      <Div key={pack.id} margin='40px 0 0 0'>
        <Div display='flex' width='100%' justifyContent='space-between' alignItems='center'>
          {
            isCreateMode
              ? <P bold color={theme.color.primaryColor}>{pack.name}</P>
              : <Input defaultValue={pack.name} onChange={(e) => {
                setInventoryOption(inventoryOption.map(variant => ({
                  ...variant,
                  pack: variant.pack.map((p) => {
                    if (p.id === pack.id) return ({ ...p, name: e.target.value })
                    return p
                  }),
                })))
              }} />
          }
          {
            _.size(inventoryOption[0].pack) > 1
              && <Trash2 className='cursor-pointer text-blue-500' onClick={() => setInventoryOption([
                {
                  ...inventoryOption[0],
                  pack: _.remove(_.cloneDeep(inventoryOption[0].pack), o => o.id !== pack.id),
                }])}
              />
          }
        </Div>
        <Row gutter={32}>
          <Col
            xs={24}
            md={12}
            lg={4}
          >
            <InputWithLabel
              width='100%'
              input={{
                width: '100%',
                // defaultValue: isCreateMode ? undefined : data.inventoryInfo.data.warehouseCode,
                placeholder: 'กรอกราคาขาย',
                state: 'default',
                defaultValue: pack.salesPrice,
                rule: { type: 'float' },
              }}
              onChange={e => setInventoryOption([
                {
                  ...inventoryOption[0],
                  pack: inventoryOption[0].pack.map((val) => {
                    if (val.id === pack.id) {
                      return ({
                        ...val,
                        salesPrice: parseFloat(e.target.value),
                      })
                    }
                    return val
                  }),
                }])}
              title={{ text: 'ราคาขายขั้นต่ำ' }}
            />
          </Col>
          {
            !isCreateMode
              && <Col
                    xs={24}
                    md={12}
                    lg={4}
                  >
                    <InputWithLabel
                      width='100%'
                      input={{
                        width: '100%',
                        // defaultValue: isCreateMode ? undefined : data.inventoryInfo.data.warehouseCode,
                        placeholder: 'กรอกจำนวนแพ๊ค',
                        state: 'default',
                        defaultValue: pack.quantity,
                        rule: { type: 'float' },
                      }}
                      onChange={(e) => {
                        setInventoryOption(inventoryOption.map(variant => ({
                          ...variant,
                          pack: variant.pack.map((p) => {
                            if (p.id === pack.id) return ({ ...p, quantity: parseInt(e.target.value, 10) })
                            return p
                          }),
                        })))
                      }}
                      title={{ text: 'จำนวนแพ๊ค' }}
                    />
                </Col>
          }
        </Row>
        {
          index + 1 < _.size(inventoryOption[0].pack)
            && <Divider
              color={theme.color.veryLightBlue}
              margin='16px 0'
            />
        }
      </Div>
    ))
  }
  {
    !isCreateMode
      && <Button
        // inverse
        // disabled={_.size(inventoryOption[0].pack) > 2}
        width='100%'
        margin='32px 0'
        text='เพิ่มแพ๊ค'
        onClick={() => {
          setInventoryOption(inventoryOption.map(v => ({ ...v, pack: [...v.pack, { id: _.maxBy(v.pack, 'id').id + 1 }] })))
        }}/>
  }
  </Div>
)

const Form = ({
  loading, isCreateMode, data, id,
}) => {
  const { loading: supLoading, data: supData, error: supError } = useQuery(SUPPLIERS)
  const { loading: cateLoading, data: cateData, error: cateError } = useQuery(CATEGORIES)
  const { loading: brandsLoading, data: brandsData, error: brandsError } = useQuery(BRANDS)
  const { loading: warehousesLoading, data: warehousesData, error: warehousesError } = useQuery(WAREHOUSES)
  const { loading: keyLoading, data: keyData, error: keyError } = useQuery(VARIANTOPTIONSKEY)
  const { loading: optionsLoading, data: optionsData, error: optionsError } = useQuery(GET_OPTIONS)
  const { loading: tagsLoading, data: tagsData, error: tagsError } = useQuery(GET_TAGS)
  const [doAction, { loading: mutationLoading }] = useMutation(isCreateMode ? CREATE_INVENTORY : UPDATE_INVENTORY)

  const [mutationVariables, setMutationVariables] = useState(
    isCreateMode
      ? {
        type: SALE_TYPE.VARIANT,
        tag: [],
        sellable: true,
        purchasable: true,
        taxable: true,
        serialTracking: true,
        stockType: STOCK_TYPE.STOCK,
      }
      : {
        type: SALE_TYPE.VARIANT,
        tag: [],
        sellable: true,
        purchasable: true,
        taxable: true,
        serialTracking: true,
        stockType: STOCK_TYPE.STOCK,
      },
  )
  const [haveVariant, setHaveVariant] = useState(false)
  const [suppliers, setSuppliers] = useState([{ id: 1, supplierId: undefined }])
  const [variants, setVariants] = useState([{ id: 1, option: undefined, value: [] }])
  const [packs, setPacks] = useState([{ id: 1, option: undefined, value: [] }])
  const [inventoryOption, setInventoryOption] = useState([])
  const [step, setStep] = useState(1)
  const [isAutomateSKU, setIsAutomateSKU] = useState(false)

  useEffect(() => {
    if (!isCreateMode && !loading) {
      setMutationVariables({
        ...mutationVariables,
        ...data.inventoryInfo.data,
      })
      setInventoryOption(data.inventoryInfo.data.inventoryOptions.map(v => ({
        ...v,
        location: v.stockLocation.map(val => ({ ...val, warehouseId: val.warehouse.id })),
      })))
      setSuppliers(data.inventoryInfo.data.supplier.map(v => ({ ...v, supplierId: v.id })))
    }
  }, [loading])

  const isPassed = verifyFields(
    isCreateMode,
    [
      mutationVariables.sku,
      suppliers,
      mutationVariables.productName,
      mutationVariables.productGroup,
      mutationVariables.stockType,
      mutationVariables.unit,
      mutationVariables.technicianName,
    ],
    { ...mutationVariables },
  )

  if (step === 1) {
    return (
      <Div>
        {
          !loading
            ? !isCreateMode && _.isNull(data.inventoryInfo.data)
              ? <H4>ไม่พบ</H4>
              : <Div display='flex' flexDirection='column'>
                  {/* <Log data={{
                    mutationVariables, packs, variants, suppliers, data, inventoryOption,
                  }}/> */}
                  <SmallText color={theme.color.primaryColor} margin='40px 0'>ขั้นตอนที่ 1/2</SmallText>
                  <SmallText bold>Supplier *</SmallText>
                    {
                      suppliers.map((v, i) => (
                        <Row type='flex' gutter={16} align='middle' key={i} style={{ margin: '16px -8px 0 -8px' }}>
                          <Col span={23}>
                            <KonsysSelect
                              style={{ width: '100%' }}
                              placeholder='เลือก Supplier ของสินค้า'
                              value={(supLoading || _.isUndefined(v.supplierId)) ? undefined : _.find(supData.supplierList.data.list, o => o.id === v.supplierId).name}
                              onChange={(e) => {
                                setSuppliers(suppliers.map((val) => {
                                  if (v.id === val.id) return { ...val, supplierId: e }
                                  return val
                                }))
                              }}
                              options={supLoading ? [] : _.remove(_.cloneDeep(supData.supplierList.data.list), o => !_.includes(suppliers.map(sup => sup.supplierId), o.id)).map(supp => ({ value: supp.id, text: supp.name }))}
                            />
                          </Col>
                          <Col span={1}>
                            { i > 0 && <Trash2 className='cursor-pointer text-blue-200' onClick={() => setSuppliers(_.remove(_.cloneDeep(suppliers), o => o.id !== v.id))}/> }
                          </Col>
                        </Row>
                      ))
                    }
                  <DashedButton icon='fal fa-plus' onClick={() => setSuppliers([...suppliers, { id: _.maxBy(suppliers, 'id').id + 1, supplierId: undefined }])} text='เพิ่ม Supplier' small margin='16px 0 8px'/>
                  <Row type='flex' gutter={16} align='middle'>
                    <Col
                      xs={24}
                      md={12}
                    >
                      <Div>
                        <SmallText bold>ชื่อสินค้า *</SmallText>
                        <Div display='flex' alignItems='center'>
                          <Input
                            width='100%'
                            value={mutationVariables.productName}
                            // defaultValue={isCreateMode ? undefined : data.inventoryInfo.data.sku}
                            onChange={e => setMutationVariables({ ...mutationVariables, productName: e.target.value })}
                          />
                        </Div>
                      </Div>
                    </Col>
                    <Col xs={24} md={6}>
                      <Div>
                        <SmallText bold>ชื่อที่ช่างเรียก *</SmallText>
                        <Input
                          width='100%'
                          value={mutationVariables.technicianName}
                          onChange={e => setMutationVariables({ ...mutationVariables, technicianName: e.target.value })}
                        />
                      </Div>
                    </Col>
                    <Col xs={24} md={6}>
                      <Div>
                        <SmallText bold>หน่วย *</SmallText>
                        <Input
                          width='100%'
                          value={mutationVariables.unit}
                          onChange={e => setMutationVariables({ ...mutationVariables, unit: e.target.value })}
                        />
                      </Div>
                    </Col>
                  </Row>
                  <Row type='flex' gutter={16} align='middle'>
                    <Col xs={24} md={6}>
                      <Div>
                        <SmallText bold>รหัสสินค้า *</SmallText>
                        <Div display='flex' alignItems='center'>
                          <Input
                            width='100%'
                            value={mutationVariables.sku}
                            disabled={isAutomateSKU}
                            // defaultValue={isCreateMode ? undefined : data.inventoryInfo.data.sku}
                            onChange={e => setMutationVariables({ ...mutationVariables, sku: e.target.value })}
                          />
                        </Div>
                      </Div>
                    </Col>
                    <Col xs={24} md={6}>
                      <SmallText bold>ยี่ห้อ</SmallText>
                      <AutoComplete
                        dataSource={brandsLoading ? [] : _.compact(brandsData?.getBrandList?.data) || []}
                        value={mutationVariables.brand}
                        style={{ width: '100%' }}
                        onSelect={e => setMutationVariables({ ...mutationVariables, brand: e })}
                        onSearch={e => setMutationVariables({ ...mutationVariables, brand: e })}
                        placeholder='เลือกยี่ห้อ'
                      />
                    </Col>
                    <Col xs={24} md={6}>
                      <SelectWithLabel
                        width='100%'
                        title={{
                          text: 'ประเภทสินค้า *',
                        }}
                        select={{
                          style: { width: '100%' },
                          value: mutationVariables.productGroup,
                          placeholder: 'เลือกประเภทสินค้า',
                          onChange: e => setMutationVariables({ ...mutationVariables, productGroup: e }),
                          options: [
                            { text: 'อะไหล่', value: PRODUCT_GROUP.PARTS },
                            // { text: 'ยาง', value: PRODUCT_GROUP.TIRES },
                            { text: 'อื่นๆ', value: PRODUCT_GROUP.OTHERS },
                          ],
                        }}
                      />
                    </Col>
                    <Col
                      xs={24}
                      md={6}
                    >
                      <SelectWithLabel
                        width='100%'
                        title={{
                          text: 'หมวดหมู่สินค้า',
                        }}
                        select={{
                          style: { width: '100%' },
                          value: mutationVariables.category,
                          placeholder: 'เลือกหมวดหมู่สินค้า',
                          onChange: e => setMutationVariables({ ...mutationVariables, category: e }),
                          options: cateLoading ? [] : cateData.getCategoryList.data.map(v => ({ text: v, value: v })),
                        }}
                      />
                    </Col>
                  </Row>
                  <Row type='flex' gutter={16} align='middle'>
                    <Col
                      xs={24}
                      md={12}
                    >
                      <SmallText bold>Ref ID</SmallText>
                        <Div display='flex' alignItems='center'>
                          <Input
                            width='100%'
                            value={mutationVariables.reference}
                            // defaultValue={isCreateMode ? undefined : data.inventoryInfo.data.sku}
                            onChange={e => setMutationVariables({ ...mutationVariables, reference: e.target.value })}
                          />
                        </Div>
                    </Col>
                    <Col
                      xs={24}
                      md={12}
                    >
                      <SmallText bold>Barcode</SmallText>
                        <Div display='flex' alignItems='center'>
                          <Input
                            width='100%'
                            value={mutationVariables.barcode}
                            // defaultValue={isCreateMode ? undefined : data.inventoryInfo.data.sku}
                            onChange={e => setMutationVariables({ ...mutationVariables, barcode: e.target.value })}
                          />
                        </Div>
                    </Col>
                  </Row>
                  <SmallText bold margin='8px 0'>แท็กของสินค้า</SmallText>
                  <Tag
                    value={!_.isNull(mutationVariables.tag) ? mutationVariables.tag.map(v => v.name) : {} }
                    mode="tags"
                    style={{ width: '100%' }}
                    placeholder="กรอกแท็กของสินค้า" onChange={e => setMutationVariables({ ...mutationVariables, tag: e.map(v => ({ name: v })) })}
                    // options={tagsLoading ? [] : tagsData.getTagList.data.map(v => ({ value: v, text: v }))}
                  >
                    {tagsLoading ? [] : tagsData.getTagList.data.map(v => <Tag.Option key={v} value={v}>{v}</Tag.Option>)}
                  </Tag>
                  <SmallText bold margin='32px 0 8px'>เลือกประเภทสต๊อกสินค้า *</SmallText>
                  <RadioGroup
                    name='paymentType'
                    disabled={!isCreateMode}
                    defaultCheckedValue={mutationVariables.stockType}
                    onChange={e => setMutationVariables({ ...mutationVariables, stockType: e.target.value })}
                    list={[{ value: STOCK_TYPE.STOCK, text: 'สินค้านับสต๊อก', margin: '0 32px 0 0' }, { value: STOCK_TYPE.SERVICE, text: 'บริการ' }]}
                  />
                  {
                    isCreateMode
                      && <Div margin='32px 0 0'>
                          {/* <SmallText bold margin='32px 0 8px'>เลือกประเภทสินค้า</SmallText>
                          <Divider
                            // color='#C2E2BF'
                            margin='40px 0'
                          /> */}
                          {/* <RadioWrapper open={!haveVariant}>
                            <Radio
                              checked={!haveVariant}
                              data={{ value: 'noVariant', text: 'ไม่มีรุ่นย่อย' }}
                              onChange={e => e.target.checked && setHaveVariant(false)}
                            />
                            <Div>
                            {
                              variants.map(v => (
                                <Row key={v.id} type='flex' gutter={16} align='middle' style={{ margin: '8px -8px' }}>
                                  <Col
                                    span={6}
                                  >
                                    <AutoComplete
                                      dataSource={keyLoading ? [] : _.remove(_.cloneDeep(keyData.getOptionKey.data), o => !_.includes(variants.map(variant => variant.option), o))}
                                      style={{ width: '100%' }}
                                      onSelect={(e) => {
                                        setVariants(variants.map((val) => {
                                          if (v.id === val.id) {
                                            return ({
                                              ...val,
                                              option: e,
                                            })
                                          } return val
                                        }))
                                      }}
                                    />
                                  </Col>
                                  <Col
                                    span={17}
                                  >
                                    <Select
                                      mode="tags"
                                      style={{ width: '100%' }}
                                      onChange={(e) => {
                                        setVariants(variants.map((val) => {
                                          if (v.id === val.id) {
                                            return ({
                                              ...val,
                                              value: e,
                                            })
                                          } return val
                                        }))
                                      }}
                                      options={!optionsLoading && !_.isUndefined(_.find(optionsData.getOptions.data, o => o.optionKey === v.option))
                                        ? _.find(optionsData.getOptions.data, o => o.optionKey === v.option).optionNames.map(option => ({ value: option, text: option }))
                                        : []
                                      }
                                    />
                                  </Col>
                                </Row>
                              ))
                            }
                            </Div>
                          </RadioWrapper> */}
                          {/* <RadioWrapper open={haveVariant} margin='24px 0 0'>
                            <Radio
                              checked={haveVariant}
                              data={{ value: 'variant', text: 'สินค้าเป็นรุ่น' }}
                              onChange={e => e.target.checked && setHaveVariant(true)}
                            />
                            <Div>
                              <Row type='flex' gutter={16} align='middle' style={{ margin: '8px -8px' }}>
                              <Col
                                span={6}
                              >
                                <SmallText bold>ชื่อตัวเลือก *</SmallText>
                              </Col>
                              <Col
                                span={17}
                              >
                                <SmallText bold>ตัวเลือก *</SmallText>
                              </Col>
                              <Col span={1}/>
                            </Row>
                            {
                              variants.map(v => (
                                <Row key={v.id} type='flex' gutter={16} align='middle' style={{ margin: '8px -8px' }}>
                                  <Col
                                    span={6}
                                  >
                                    <AutoComplete
                                      dataSource={keyLoading ? [] : _.remove(_.cloneDeep(keyData.getOptionKey.data), o => !_.includes(variants.map(variant => variant.option), o))}
                                      style={{ width: '100%' }}
                                      onSelect={(e) => {
                                        setVariants(variants.map((val) => {
                                          if (v.id === val.id) {
                                            return ({
                                              ...val,
                                              option: e,
                                            })
                                          } return val
                                        }))
                                      }}
                                      onSearch={(e) => {
                                        setVariants(variants.map((val) => {
                                          if (v.id === val.id) {
                                            return ({
                                              ...val,
                                              option: e,
                                            })
                                          } return val
                                        }))
                                      }}
                                      placeholder="ใส่"
                                    />
                                  </Col>
                                  <Col
                                    span={17}
                                  >
                                    <Select
                                      mode="tags"
                                      style={{ width: '100%' }}
                                      onChange={(e) => {
                                        setVariants(variants.map((val) => {
                                          if (v.id === val.id) {
                                            return ({
                                              ...val,
                                              value: e,
                                            })
                                          } return val
                                        }))
                                      }}
                                      loading={optionsLoading}
                                      options={!optionsLoading && !_.isUndefined(_.find(optionsData.getOptions.data, o => o.optionKey === v.option))
                                        ? _.find(optionsData.getOptions.data, o => o.optionKey === v.option).optionNames.map(option => ({ value: option, text: option }))
                                        : []
                                      }
                                    />
                                  </Col>
                                  <Col span={1}>
                                    <Icon icon='fal fa-trash-alt' color={theme.color.blue} style={{ cursor: 'pointer' }} onClick={() => setVariants(_.remove(_.cloneDeep(variants), o => o.id !== v.id))}/>
                                  </Col>
                                </Row>
                              ))
                            }
                            <DashedButton
                              disabled={_.size(variants) >= 3}
                              text='เพิ่ม Variant ใหม่' icon='fal fa-plus'
                              onClick={() => {
                                if (variants.length === 0) setVariants([{ id: 1, option: undefined, value: [] }])
                                else setVariants([...variants, { id: _.maxBy(variants, 'id').id + 1, option: undefined, value: [] }])
                              }}
                              margin='16px 0 8px'
                              padding='8px 16px'
                              width='100%'
                            />
                            </Div>
                          </RadioWrapper> */}
                          {/* <RadioWrapper margin='24px 0 0' open={mutationVariables.type === SALE_TYPE.PACK}>
                            <Radio
                              checked={mutationVariables.type === SALE_TYPE.PACK}
                              data={{ value: 'pack', text: 'สินค้าเป็นแพ็ค' }}
                              onChange={e => e.target.checked && setMutationVariables({ ...mutationVariables, type: SALE_TYPE.PACK })}
                            />
                            <Div>
                            <Row type='flex' gutter={16} align='middle' style={{ margin: '8px -8px' }}>
                              <Col
                                span={18}
                              >
                                <SmallText bold>ชื่อแพ็ค</SmallText>
                              </Col>
                              <Col
                                span={5}
                              >
                                <SmallText bold>จำนวน / แพ็ค</SmallText>
                              </Col>
                              <Col span={1}/>
                            </Row>
                            {
                              packs.map(v => (
                                <Row key={v.id} type='flex' gutter={16} align='middle' style={{ margin: '8px -8px' }}>
                                  <Col
                                    span={18}
                                  >
                                    <Input width='100%' onChange={(e) => {
                                      setPacks(packs.map((val) => {
                                        if (v.id === val.id) {
                                          return ({
                                            ...val,
                                            option: e.target.value,
                                          })
                                        } return val
                                      }))
                                    }} />
                                  </Col>
                                  <Col
                                    span={5}
                                  >
                                    <Input width='100%' onChange={(e) => {
                                      setPacks(packs.map((val) => {
                                        if (v.id === val.id) {
                                          return ({
                                            ...val,
                                            value: parseInt(e.target.value, 10),
                                          })
                                        } return val
                                      }))
                                    }} state='default' rule={{ type: 'int' }}/>
                                  </Col>
                                  <Col span={1}>
                                    <Icon icon='fal fa-trash-alt' color={theme.color.blue} style={{ cursor: 'pointer' }} onClick={() => setPacks(_.remove(_.cloneDeep(packs), o => o.id !== v.id))}/>
                                  </Col>
                                </Row>
                              ))
                            }
                            <DashedButton
                              // disabled={_.size(packs) >= 3}
                              text='เพิ่มแพ็คใหม่' icon='fal fa-plus'
                              onClick={() => setPacks([...packs, { id: _.maxBy(packs, 'id').id + 1, option: undefined, value: [] }])}
                              margin='16px 0 8px'
                              padding='8px 16px'
                              width='100%'
                            />
                            </Div>
                          </RadioWrapper> */}
                          <Divider
                            margin='40px 0'
                          />
                        </Div>
                  }
                  <Div display='flex' flexDirection='row' justifyContent='center' alignItems='center' width='100%' margin='20px 0'>
                    <Link to='/inventory'>
                      <Button
                        color={theme.color.error}
                        loading={mutationLoading}
                        text='ยกเลิก'
                        icon='fal fa-times'
                        style={{ alignItems: 'center' }}
                        width='fit-content'
                        margin='0 4px'
                      />
                    </Link>
                    <Button
                      loading={mutationLoading}
                      disabled={isPassed || (isCreateMode && haveVariant && (variants.length === 0 || _.isUndefined(variants[0].option) || variants[0].value.length === 0))}
                      text='ถัดไป (กรอกข้อมูลสต๊อก)'
                      rightIcon={true}
                      icon='fal fa-arrow-right'
                      style={{ alignItems: 'center' }}
                      width='fit-content'
                      margin='0 4px'
                      onClick={() => {
                        if (isCreateMode) {
                          if (mutationVariables.type === SALE_TYPE.VARIANT) {
                            if (!haveVariant) {
                              setInventoryOption([
                                {
                                  id: 1,
                                  variantName: mutationVariables.productName,
                                  optionKey1: mutationVariables.productName,
                                  optionName1: mutationVariables.productName,
                                  ...initialNewVariantData,
                                  location: [{
                                    id: 1,
                                    ...initialNewLocationData,
                                  }],
                                },
                              ])
                            } else if (_.size(variants) > 1) {
                              const prepare = variants.map(variant => (
                                variant.value.map(val => (val))
                              ))
                              const inventory = prepare.reduce((a, b) => a.reduce((r, v) => r.concat(b.map(w => [].concat(v, w))), [])).map(v => _.omitBy((
                                {
                                  id: _.join(v, ' / '),
                                  variantName: _.join(v, ' / '),
                                  optionKey1: variants[0] ? variants[0].option : null,
                                  optionName1: v[0] ? v[0] : null,
                                  optionKey2: variants[1] ? variants[1].option : null,
                                  optionName2: v[1] ? v[1] : null,
                                  optionKey3: variants[2] ? variants[2].option : null,
                                  optionName3: v[2] ? v[2] : null,
                                  ...initialNewVariantData,
                                  location: [{
                                    id: 1,
                                    ...initialNewLocationData,
                                  }],
                                }
                              ), o => _.isNull(o)))
                              setInventoryOption(inventory)
                            } else {
                              setInventoryOption(variants[0].value.map(v => (
                                {
                                  id: _.join(v),
                                  variantName: v,
                                  optionKey1: variants[0].option,
                                  optionName1: v,
                                  ...initialNewVariantData,
                                  location: [{
                                    id: 1,
                                    ...initialNewLocationData,
                                  }],
                                }
                              )))
                            }
                          } else {
                            setInventoryOption([{
                              id: mutationVariables.sku,
                              variantName: mutationVariables.productName,
                              optionKey1: 'รูปแบบ',
                              optionName1: 'ปกติ',
                              ...initialNewVariantData,
                              location: [{
                                id: 1,
                                ...initialNewLocationData,
                              }],
                              pack: packs.map(v => ({
                                id: v.id,
                                name: v.option,
                                quantity: v.value,
                                salesPrice: undefined,
                              })),
                            }])
                          }
                        }
                        setStep(2)
                      }}
                    />
                  </Div>
                </Div>
            : null
        }
      </Div>
    )
  }

  const variantRequiredFields = [
    ...inventoryOption.map(v => ({
      initialCost: v.initialCost,
      initialStock: v.initialStock,
      sku: v.sku,
    })),
    ...inventoryOption.map(v => v.location),
  ]

  const editVariantRequiredFields = [
    ...inventoryOption.map(v => ({
      initialCost: v.initialCost,
      initialStock: v.initialStock,
      sku: v.sku,
    })),
  ]

  const packRequiredFields = [
    ...inventoryOption.map(v => ({
      buyPrice: v.buyPrice,
      initialCost: v.initialCost,
      initialStock: v.initialStock,
      isVat: v.isVat,
      minimumStock: v.minimumStock,
      sku: v.sku,
    })),
    ...inventoryOption.map(v => v.location),
    ...inventoryOption.map(v => v.pack),
  ]

  return (
    <Div>
      {
        !loading
          ? !isCreateMode && _.isNull(data.inventoryInfo.data)
            ? <H4>ไม่พบ</H4>
            : <Div display='flex' flexDirection='column'>
                {/* <Log data={{
                  mutationVariables, packs, variants, suppliers, inventoryOption,
                }} /> */}
                <SmallText color={theme.color.primaryColor} margin='40px 0'>ขั้นตอนที่ 2/2</SmallText>
                {
                  mutationVariables.type === SALE_TYPE.VARIANT
                    ? <VariantOptionForm inventoryOption={inventoryOption} setInventoryOption={setInventoryOption} isCreateMode={isCreateMode} data={data} warehousesData={warehousesData}/>
                    : <PackOptionForm inventoryOption={inventoryOption} setInventoryOption={setInventoryOption} isCreateMode={isCreateMode} data={data} warehousesData={warehousesData}/>
                }
                <Div display='flex' flexDirection='row' justifyContent='center' alignItems='center' width='100%' margin='20px 0'>
                  <Button
                    disabled={mutationLoading}
                    text='กลับไปใส่ข้อมูลเบื้องต้น'
                    icon='fal fa-arrow-left'
                    style={{ alignItems: 'center' }}
                    width='fit-content'
                    margin='0 4px'
                    onClick={() => {
                      setStep(1)
                    }}
                  />
                  <Button
                    color={theme.color.success}
                    loading={mutationLoading}
                    inverse
                    disabled={
                      mutationLoading
                      || verifyFields(
                        isCreateMode,
                        isCreateMode ? variantRequiredFields : editVariantRequiredFields,
                        inventoryOption,
                      )
                      || (
                        !isCreateMode
                        && _.some(_.flatten(inventoryOption.map(v => v.location)), v => v.isNew && _.isUndefined(v.warehouseId))
                        // _.some(inventoryOption.location, v => _.values(v))
                      )
                      // || _.sum(inventoryOption.map(v => v.initialStock)) !== _.sum(_.flatten(inventoryOption.map(v => v.location)).map(v => v.quantity))
                      // || _.size(_.uniq(inventoryOption.map(v => v.sku))) !== _.size(inventoryOption)
                    }
                    text={isCreateMode ? 'สร้างสินค้าใหม่' : 'แก้ไขสต๊อกสินค้า' }
                    rightIcon={true}
                    icon={isCreateMode ? 'fal fa-plus' : 'fal fa-edit' }
                    style={{ alignItems: 'center' }}
                    width='fit-content'
                    margin='0 4px'
                    onClick={() => {
                      if (_.size(_.uniq(inventoryOption.map(v => v.sku))) !== _.size(inventoryOption)) {
                        notification.error({
                          message: 'รหัส SKU ของรุ่นย่อยซ้ำกัน',
                        })
                        return
                      }
                      if (isCreateMode && _.sum(inventoryOption.map(v => v.initialStock)) !== _.sum(_.flatten(inventoryOption.map(v => v.location)).map(v => v.quantity))) {
                        notification.error({
                          message: 'สต๊อกเริ่มต้นไม่เท่าสต๊อกในคลัง',
                        })
                        return
                      }
                      doAction({
                        variables: isCreateMode
                          ? {
                            ...mutationVariables,
                            supplierId: suppliers.map(v => v.supplierId),
                            inventoryOption: inventoryOption.map(v => (_.omit({
                              ...v,
                              file: v.file ? v.file[0] : undefined,
                              location: v.location.map(lv => _.omit(lv, 'id', 'isNew')),
                            }, ['id', 'variantName']))),
                          }
                          : _.omit({
                            ...mutationVariables,
                            tag: mutationVariables.tag.map(v => ({ name: v.name })),
                            supplierId: suppliers.map(v => v.supplierId),
                            inventoryOption: inventoryOption.map(v => ({
                              id: v.isNew ? undefined : v.id,
                              variantName: v.variantName,
                              sku: v.sku,
                              minimumStock: v.minimumStock,
                              initialStock: v.initialStock,
                              salesPrice: v.salesPrice,
                              buyPrice: v.buyPrice,
                              vat: v.vat,
                              file: !_.isEmpty(v.file) ? v.file[0] : _.isUndefined(v.file) ? undefined : null,
                              location: v.location.map(location => ({
                                locationId: _.includes(location.id, '_NEW') || location.isNew ? undefined : location.id, warehouseId: location.warehouseId, shelf: location.shelf, quantity: location.quantity,
                              })),
                            })),
                          }, ['initialCost', 'inventoryOptions', 'supplier', 'type', '__typename']),
                        refetchQueries: [{ query: INVENTORIES, variables: { limit: 5, offset: 0 } }],
                      }).then((resp) => {
                        const KEY = isCreateMode ? 'createInventory' : 'updateInventory'
                        if (resp.data[KEY].success) {
                          message.success(resp.data[KEY].message)
                          history.push('/inventory')
                        } else message.error(resp.data[KEY].message)
                      })
                    }}
                  />
                </Div>
              </Div>
          : null
      }
    </Div>
  )
}

export default ({ props }) => {
  const isCreateMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const { loading, data, error } = useQuery(INVENTORY, { skip: isCreateMode, variables: { id: parseInt(props.match.params.id, 10) } })

  return <Form data={data} loading={loading} isCreateMode={isCreateMode} id={parseInt(props.match.params.id, 10)}/>
}
